
  export default {
    props: {
      menuData: {
        type: Object,
        default: () => (null)
      }
    },
    data () {
      return {
        height: '440px'
      };
    },
    computed: {
      arrowPos () {
        if (this.menuData.category === 'energy') {
          return this.user ? '40%' : '34%';
        } else if (this.menuData.category === 'insurance') {
          return this.user ? '51%' : '45%';
        } else if (this.menuData.category === 'broadband') {
          return this.user ? '60%' : '54%';
        } else if (this.menuData.category === 'mortgages') {
          return this.user ? '69%' : '62%';
        } else if (this.menuData.category === 'banking') {
          return this.user ? '77%' : '71%';
        } else if (this.menuData.category === 'newsroom') {
          return this.user ? '86%' : '89.5%';
        } else if (this.menuData.category === 'user') {
          return '73%';
        }
        return '55%';
      },
      ctaDescription () {
        if (this.menuData.category === 'energy') {
          const saving = this.$store.getters['utils/getAmounts'].energy_saving;
          return `${this.menuData.cta.desc} ${this.$n(saving, 'currency')}*`;
        } else if (this.menuData.category === 'broadband') {
          const saving = this.$store.getters['utils/getAmounts'].cheapest_broadband;
          return `${this.menuData.cta.desc} ${this.$n(saving, 'currency')}*`;
        } else {
          return this.menuData.cta.desc;
        }
      },
      user () {
        return this.$store.getters['user/get'];
      }
    },
    methods: {
      resizeBox: function () {
        this.$nextTick(() => {
          // .dynamic-menu(:style="{height: height}")
          let content = this.$refs.navContent;
          // console.log(content);
          // console.log(content.offsetHeight);
          this.height = `${content.offsetHeight}px`;
        });
      },
      hovering: function () {
        this.$emit('hovering-menu');
      },
      notHovering: function () {
        this.$emit('not-hovering-menu');
      }
    }

  };
